import React from "react"
import AdvisoryBoardComponent from "./AdvisoryBoard"
import advisoryBoardFactory from "./advisoryBoard.factory"

export { default as AdvisoryBoardQuery } from "./advisoryBoard.query"

export const AdvisoryBoard = props => {
  const { data } = props
  const componentProps = { ...props, ...advisoryBoardFactory.transform(data) }
  return <AdvisoryBoardComponent {...componentProps} />
}
